import { Suspense, lazy } from "react";

const RenameHeraldConversationModal = lazy(
  () => import("./RenameHeraldConversationModal"),
);
const DeleteHeraldConversationModal = lazy(
  () => import("./DeleteHeraldConversationModal"),
);

/**
 * Herald chat modals (mount once at route level; same idea as NewsFeedModals).
 */
const HeraldChatModals = () => {
  return (
    <Suspense fallback={null}>
      <RenameHeraldConversationModal />
      <DeleteHeraldConversationModal />
    </Suspense>
  );
};

export default HeraldChatModals;
